import {
  BooleanInput,
  ReferenceInput,
  required,
  SelectInput,
  TextInput,
} from 'react-admin';
import { QuickbooksPriceInput } from '../components/QuickbooksPriceInput';
import { itemsTypes } from './items-types';

export const BaseItemEdit = () => (
  <>
    <SelectInput source="Type" choices={itemsTypes} validate={[required()]} />
    <TextInput source="Name" validate={[required()]} />
    <TextInput source="Description" />
    <QuickbooksPriceInput source="UnitPrice" />
    <ReferenceInput source="IncomeAccountRef.value" reference="accounts">
      <SelectInput
        label="resources.items.fields.IncomeAccount"
        optionText="FullyQualifiedName"
      />
    </ReferenceInput>
    <ReferenceInput source="ExpenseAccountRef.value" reference="accounts">
      <SelectInput
        label="resources.items.fields.ExpenseAccount"
        optionText="FullyQualifiedName"
      />
    </ReferenceInput>
    <ReferenceInput source="PurchaseTaxCodeRef.value" reference="taxes">
      <SelectInput label="resources.items.fields.Tax" optionText="Name" />
    </ReferenceInput>
    <BooleanInput source="Taxable" />
  </>
);
